export const MonsterSpriteNames = {

    /////////////////////////////////////////
    // ROW 0
    /////////////////////////////////////////

    AQUATIC_SNAKE_TAN_1: "AQUATIC_SNAKE_TAN1",
    AQUATIC_SNAKE_TAN_2: "AQUATIC_SNAKE_TAN2",
    AQUATIC_SNAKE_BLACK_1: "AQUATIC_SNAKE_BLACK1",
    AQUATIC_SNAKE_BLACK_2: "AQUATIC_SNAKE_BLACK2",
    AQUATIC_MONSTER: "AQUATIC_MONSTER",
    AVIAN_BAT_BROWN_SMALL: "AVIAN_BAT_BROWN_SMALL",
    AVIAN_BAT_BROWN_LARGE: "AVIAN_BAT_BROWN_LARGE",
    AVIAN_BAT_BLACK_LARGE: "AVIAN_BAT_BLACK_LARGE",

    /////////////////////////////////////////
    // ROW 1
    /////////////////////////////////////////

    AVIAN_BAT_BROWN_SMALL2: "AVIAN_BAT_BROWN_SMALL2",
    AVIAN_BAT_BROWN_LARGE2: "AVIAN_BAT_BROWN_LARGE2",
    DEMON_REPTILIAN_GREEN: "DEMON_REPTILIAN_GREEN",
    DEMON_REPTILIAN_WINGED: "DEMON_REPTILIAN_WINGED",
    DEMON_BROWN: "DEMON_BROWN",
    DEMON_BLOB: "DEMON_BLOB",
    DEMON_BLUE: "DEMON_BLUE",
    DEMON_BLUE_WINGED: "DEMON_BLUE_WINGED",

    /////////////////////////////////////////
    // ROW 2
    /////////////////////////////////////////

    DEMON_RED_GLOWING: "DEMON_RED_GLOWING",
    DEMON_RED_WINGED_1: "DEMON_RED_WINGED1",
    DEMON_RED_WINGED_2: "DEMON_RED_WINGED2",
    DEMON_RED_DARK_LARGE: "DEMON_RED_DARK_LARGE",
    DEMON_RED_LARGE: "DEMON_RED_LARGE",
    DEMON_RED_PALE_LARGE: "DEMON_RED_PALE_LARGE",
    DEMON_BLUE_LARGE: "DEMON_BLUE_LARGE",
    DEMON_BLUE_RED_LARGE: "DEMON_BLUE_RED_LARGE",

    /////////////////////////////////////////
    // ROW 3
    /////////////////////////////////////////

    DEMON_GREEN_EYE_STOCKS: "DEMON_GREEN_EYE_STOCKS",
    DEMON_GREEN_EVIL_WINGED: "DEMON_GREEN_EVIL_WINGED",
    DEMON_RED_DARK_WHIP: "DEMON_RED_DARK_WHIP",
    DEMON_RED_TINY_JUMPING: "DEMON_RED_TINY_JUMPING",
    DEMON_RED_SMALL_JUMPING: "DEMON_RED_SMALL_JUMPING",
    DEMON_ARMORED: "DEMON_ARMORED",
    DEMON_HELMET_HORNED: "DEMON_HELMET_HORNED",
    DEMON_RED_FANGED: "DEMON_RED_FANGED",

    /////////////////////////////////////////
    // ROW 4
    /////////////////////////////////////////

    DEMON_GREEN_FROG_LIKE: "DEMON_GREEN_FROG_LIKE",
    ELEMENTAL_WARRIOR: "ELEMENTAL_WARRIOR",
    ELEMENTAL_SQUID: "ELEMENTAL_SQUID",
    ELEMENTAL_GOLEM: "ELEMENTAL_GOLEM",
    ELEMENTAL_GOLEM_DARK: "ELEMENTAL_GOLEM_DARK",
    ELEMENTAL_GOLEM_RUSTY: "ELEMENTAL_GOLEM_RUSTY",
    ELEMENTAL_BLOODY: "ELEMENTAL_BLOODY",
    ELEMENTAL_STONE: "ELEMENTAL_STONE",


    /////////////////////////////////////////
    // ROW 5
    /////////////////////////////////////////

    ELEMENTAL_SWIRL_ORANGE: "ELEMENTAL_SWIRL_ORANGE",
    ELEMENTAL_SWIRL_YELLOW: "ELEMENTAL_SWIRL_YELLOW",
    ELEMENTAL_SWIRL_BLUE_DARK: "ELEMENTAL_SWIRL_BLUE_DARK",
    ELEMENTAL_SWIRL_BLUE_LIGHT: "ELEMENTAL_SWIRL_BLUE_LIGHT",
    ELEMENTAL_SWIRL_RED: "ELEMENTAL_SWIRL_RED",
    ELEMENTAL_CREEPY_RED: "ELEMENTAL_CREEPY_RED",
    ELEMENTAL_CREEPY_BROWN: "ELEMENTAL_CREEPY_BROWN",
    ELEMENTAL_CREEPY_LIGHT_BLUE: "ELEMENTAL_CREEPY_LIGHT_BLUE",

    /////////////////////////////////////////
    // ROW 6
    /////////////////////////////////////////

    ELEMENTAL_BALL_GREEN: "ELEMENTAL_BALL_GREEN",
    ELEMENTAL_BALL_BLUE: "ELEMENTAL_BALL_BLUE",
    ELEMENTAL_BALL_RED: "ELEMENTAL_BALL_RED",
    ELEMENTAL_BALL_BLACK: "ELEMENTAL_BALL_BLACK", 
    ELEMENTAL_EYE_WHITE: "ELEMENTAL_EYE_WHITE",
    ELEMENTAL_EYE_RED: "ELEMENTAL_EYE_RED",
    ELEMENTAL_EYE_BEHOLDER: "ELEMENTAL_EYE_BEHOLDER",
    HUMANOID_210_SASQUATCH: "HUMANOID_210_SASQUATCH",

    /////////////////////////////////////////
    // ROW 7
    /////////////////////////////////////////

    HUMANOID_000: "HUMANOID_000",
    HUMANOID_001: "HUMANOID_001",
    HUMANOID_002: "HUMANOID_002",
    HUMANOID_003: "HUMANOID_003",
    HUMANOID_004: "HUMANOID_004",
    HUMANOID_005: "HUMANOID_005",
    HUMANOID_006: "HUMANOID_006",
    HUMANOID_007: "HUMANOID_007",

    /////////////////////////////////////////
    // ROW 8
    /////////////////////////////////////////

    HUMANOID_010_MINOTAUR: "HUMANOID_010_MINOTAUR",
    HUMANOID_011_CYCLOPS: "HUMANOID_011_CYCLOPS",
    HUMANOID_040_WALRUS_MAN: "HUMANOID_040_WALRUS_MAN",
    HUMANOID_041_WALRUS_MAN: "HUMANOID_041_WALRUS_MAN",
    HUMANOID_042_WALRUS_MAN: "HUMANOID_042_WALRUS_MAN",
    HUMANOID_043_WALRUS_MAN: "HUMANOID_043_WALRUS_MAN",
    HUMANOID_044_WALRUS_MAN: "HUMANOID_044_WALRUS_MAN",
    HUMANOID_045_WALRUS_MAN: "HUMANOID_045_WALRUS_MAN",

    /////////////////////////////////////////
    // ROW 9
    /////////////////////////////////////////

    HUMANOID_046_WALRUS_MAN: "HUMANOID_046_WALRUS_MAN",
    HUMANOID_070: "HUMANOID_070",
    HUMANOID_071: "HUMANOID_071",
    HUMANOID_072: "HUMANOID_072",
    HUMANOID_073: "HUMANOID_073",
    HUMANOID_170_STONE_SERPENT: "HUMANOID_170_STONE_SERPENT",
    HUMANOID_171_STONE_SERPENT: "HUMANOID_171_STONE_SERPENT",
    MISC_ANIMAL_70: "MISC_ANIMAL_70",

    /////////////////////////////////////////
    // ROW 10
    /////////////////////////////////////////

    HUMANOID_190_DEMON_BASHER: "HUMANOID_190_DEMON_BASHER",
    HUMANOID_191_DEMON_BASHER: "HUMANOID_191_DEMON_BASHER",
    HUMANOID_200_SQUID_DEMON: "HUMANOID_200_SQUID_DEMON",
    HUMANOID_201_SQUID_DEMON: "HUMANOID_201_SQUID_DEMON",
    MISC_ANIMAL_03_OWL: "MISC_ANIMAL_03_OWL",
    MISC_ANIMAL_04: "MISC_ANIMAL_04",
    MISC_ANIMAL_05: "MISC_ANIMAL_05",
    MISC_ANIMAL_06: "MISC_ANIMAL_06",

    /////////////////////////////////////////
    // ROW 11
    /////////////////////////////////////////

    MISC_ANIMAL_11: "MISC_ANIMAL_11",
    MISC_ANIMAL_12: "MISC_ANIMAL_12",
    MISC_ANIMAL_50: "MISC_ANIMAL_50",
    MISC_ANIMAL_51: "MISC_ANIMAL_51",
    MISC_ANIMAL_52: "MISC_ANIMAL_52",
    MISC_ANIMAL_53: "MISC_ANIMAL_53",
    PEST_LADYBUG_100: "PEST_LADYBUG_100",
    PEST_LADYBUG_101: "PEST_LADYBUG_101",

    /////////////////////////////////////////
    // ROW 12
    /////////////////////////////////////////

    PEST_TINY_00: "PEST_TINY_00",
    PEST_TINY_01: "PEST_TINY_01",
    PEST_TINY_02: "PEST_TINY_02",
    PEST_TINY_03: "PEST_TINY_03",
    PEST_TINY_04: "PEST_TINY_04",
    PEST_TINY_05: "PEST_TINY_05",
    PEST_TINY_WORM_1: "PEST_TINY_WORM1",
    PEST_TINY_WORM_2: "PEST_TINY_WORM2",

    /////////////////////////////////////////
    // ROW 13
    /////////////////////////////////////////

    PEST_ANT_10: "PEST_INSECT_10",
    PEST_INSECT_11: "PEST_INSECT_11",
    PEST_INSECT_12: "PEST_INSECT_12",
    PEST_INSECT_13: "PEST_INSECT_13",
    PEST_INSECT_14: "PEST_INSECT_14",
    PEST_SPIDER_20: "PEST_SPIDER_20",
    PEST_SPIDER_21: "PEST_SPIDER_21",
    PEST_SPIDER_22: "PEST_SPIDER_22",


    /////////////////////////////////////////
    // ROW 14
    /////////////////////////////////////////

    PEST_SCORPION_23: "PEST_SCORPION_23",
    PEST_SCORPION_24: "PEST_SCORPION_24",
    PEST_SCORPION_25: "PEST_SCORPION_25",
    PEST_WORM_30: "PEST_WORM_30",
    PEST_WORM_31: "PEST_WORM_31",
    PEST_BALL: "PEST_BALL",
    PEST_WORM_33: "PEST_WORM_33",
    PEST_WORM_34: "PEST_WORM_34",

    /////////////////////////////////////////
    // ROW 15
    /////////////////////////////////////////

    PEST_GIANT_ANT_40: "PEST_GIANT_ANT_40",
    PEST_GIANT_ANT_41: "PEST_GIANT_ANT_41",
    PEST_GIANT_ANT_42: "PEST_GIANT_ANT_42",
    PEST_GIANT_ANT_43: "PEST_GIANT_ANT_43",
    PEST_SLUG_70: "PEST_SLUG_70",
    PEST_SLUG_71: "PEST_SLUG_71",
    PEST_SNAIL_72: "PEST_SNAIL_72",
    PEST_SNAIL_73: "PEST_SNAIL_73",

    /////////////////////////////////////////
    // ROW 16
    /////////////////////////////////////////

    PEST_INSECT_60: "PEST_INSECT_60",
    PEST_INSECT_61: "PEST_INSECT_61",
    PEST_INSECT_80: "PEST_INSECT_80",
    PEST_INSECT_81: "PEST_INSECT_81",
    MINOR_DEVIL: "PLAYER_130_MINOR_DEVIL",
    MINOR_DEVIL_WARRIOR: "PLAYER_131_MINOR_DEVIL_WARRIOR",

    // BLANK
    // BLANK

    /////////////////////////////////////////
    // ROW 17
    /////////////////////////////////////////

    ORC1: "PLAYER_120_ORC",
    ORC_WARRIOR: "PLAYER_121_ORC_WARRIOR",
    ORC_FIGHTER: "PLAYER_122_ORC_FIGHTER",
    ORC_KARATE: "PLAYER_123_ORC_KARATE",
    ORC_PIRATE: "PLAYER_124_ORC_PIRATE",
    ORC2: "PLAYER_125_ORC",
    ORC3: "PLAYER_126_ORC",
    ORC4: "PLAYER_127_ORC",


    /////////////////////////////////////////
    // ROW 18
    /////////////////////////////////////////

    DRAGON_MAN_BASIC: "PLAYER_140_DRAGON_MAN_BASIC",
    DRAGON_MAN_EXPLORER: "PLAYER_141_DRAGON_MAN_EXPLORER",
    DRAGON_MAN_FIGHTER: "PLAYER_142_DRAGON_MAN_FIGHTER",
    DRAGON_MAN_RUFFIAN: "PLAYER_143_DRAGON_MAN_RUFFIAN",
    DRAGON_MAN_RANGER: "PLAYER_144_DRAGON_MAN_RANGER",
    DRAGON_MAN_TERRIBLE: "PLAYER_145_DRAGON_MAN_TERRIBLE",
    DRAGON_MAN_MERCILESS: "PLAYER_146_DRAGON_MAN_MERCILESS",
    DRAGON_MAN_FIERY: "PLAYER_147_DRAGON_MAN_FIERY",

    /////////////////////////////////////////
    // ROW 19
    /////////////////////////////////////////

    QUADRUPED_000: "QUADRUPED_000",
    QUADRUPED_001: "QUADRUPED_001",
    QUADRUPED_002: "QUADRUPED_002",
    QUADRUPED_003: "QUADRUPED_003",
    QUADRUPED_004: "QUADRUPED_004",
    QUADRUPED_005: "QUADRUPED_005",
    QUADRUPED_006: "QUADRUPED_006",
    QUADRUPED_007: "QUADRUPED_007",

    /////////////////////////////////////////
    // ROW 20
    /////////////////////////////////////////

    RODENT_10_RAT_SMALL: "RODENT_10_RAT_SMALL",
    RODENT_11_RAT: "RODENT_11_RAT",
    RODENT_12_RAT_LARGE_BROWN: "RODENT_12_RAT_LARGE_BROWN",
    RODENT_13_RAT_LARGE_GREY: "RODENT_13_RAT_LARGE_GREY",
    RODENT_20_RAT_POISONOUS: "RODENT_20_RAT_POISONOUS",
    RODENT_21_RAT_ZOMBIE: "RODENT_21_RAT_ZOMBIE",
    RODENT_22_MOLE: "RODENT_22_MOLE",

    // BLANK

    /////////////////////////////////////////
    // ROW 21
    /////////////////////////////////////////

    SLIME_BLUE_00: "SLIME_BLUE_00",
    SLIME_BROWN_01: "SLIME_BROWN_01",
    SLIME_WHITE_02: "SLIME_WHITE_02",
    SLIME_GREEN_03: "SLIME_GREEN_03",
    SLIME_PINK_04: "SLIME_PINK_04",
    SLIME_PURPLE_05: "SLIME_PURPLE_05",
    SLIME_MUCUS_GREEN_40: "SLIME_MUCUS_GREEN_40",
    SLIME_MUCUS_BLUE_41: "SLIME_MUCUS_BLUE_41",

    /////////////////////////////////////////
    // ROW 22
    /////////////////////////////////////////

    SLIME_CORRODED_20: "SLIME_CORRODED_20",
    SLIME_SEEING_21: "SLIME_SEEING_21",
    SLIME_ORANGE_22: "SLIME_ORANGE_22",
    SLIME_MINI_BLUE_30: "SLIME_MINI_BLUE_30",
    SLIME_MINI_31: "SLIME_MINI_31",
    SLIME_MINI_ORANGE_32: "SLIME_MINI_ORANGE_32",
    UNDEAD_WRAITH_0600: "UNDEAD_WRAITH_0600",
    UNDEAD_WRAITH_0601: "UNDEAD_WRAITH_0601",

    /////////////////////////////////////////
    // ROW 23
    /////////////////////////////////////////

    UNDEAD_GOBLIN0: "UNDEAD_GOBLIN0",   // small undead goblin
    UNDEAD_GOBLIN1: "UNDEAD_GOBLIN1",
    UNDEAD_GOBLIN2: "UNDEAD_GOBLIN2",
    UNDEAD_GOBLIN3: "UNDEAD_GOBLIN3",
    UNDEAD_GOBLIN4: "UNDEAD_GOBLIN4",   // undead goblin
    UNDEAD_GOBLIN5: "UNDEAD_GOBLIN5",
    UNDEAD_GOBLIN6: "UNDEAD_GOBLIN6",
    UNDEAD_GOBLIN7: "UNDEAD_GOBLIN7",   // large undead goblin

    /////////////////////////////////////////
    // ROW 24
    /////////////////////////////////////////

    UNDEAD_KOBOLD_SKELETON_0200: "UNDEAD_KOBOLD_SKELETON_0200",
    UNDEAD_KOBOLD_SKELETON_0201: "UNDEAD_KOBOLD_SKELETON_0201",
    UNDEAD_KOBOLD_SKELETON_0202: "UNDEAD_KOBOLD_SKELETON_0202",
    UNDEAD_KOBOLD_SKELETON_0203: "UNDEAD_KOBOLD_SKELETON_0203",
    UNDEAD_KOBOLD4: "UNDEAD_KOBOLD4",
    UNDEAD_KOBOLD5: "UNDEAD_KOBOLD5",
    UNDEAD_KOBOLD_KING_0206: "UNDEAD_KOBOLD_KING_0206",
    UNDEAD_KOBOLD_ANCIENT_EVIL7: "UNDEAD_KOBOLD_ANCIENT_EVIL7",

    /////////////////////////////////////////
    // ROW 25
    /////////////////////////////////////////

    UNDEAD_GHOST_0400: "UNDEAD_GHOST_0400",
    UNDEAD_GHOST_0401: "UNDEAD_GHOST_0401",
    UNDEAD_GHOST_0402: "UNDEAD_GHOST_0402",
    UNDEAD_GHOST_0403: "UNDEAD_GHOST_0403",
    UNDEAD_REAPER_0500: "UNDEAD_REAPER_0500",
    UNDEAD_REAPER_0501: "UNDEAD_REAPER_0501",
    UNDEAD_REAPER_0502: "UNDEAD_REAPER_0502",
    UNDEAD_DARKNESS_0801: "UNDEAD_DARKNESS_0801",

    /////////////////////////////////////////
    // ROW 26
    /////////////////////////////////////////

    REPTILE_FLYING_SERPENT_SMALL_002: "REPTILE_FLYING_SERPENT_SMALL_002",
    REPTILE_FLYING_SERPENT_003: "REPTILE_FLYING_SERPENT_003",


    /////////////////////////////////////////
    // ROW 27
    /////////////////////////////////////////

    REPTILE_BROWN_SERPENT_SMALL_040: "REPTILE_BROWN_SERPENT_SMALL_040",
    REPTILE_BROWN_SERPENT_041: "REPTILE_BROWN_SERPENT_041",
    REPTILE_BROWN_SERPENT_LARGE_042: "REPTILE_BROWN_SERPENT_LARGE_042",
    REPTILE_BLACK_SERPENT_043: "REPTILE_BLACK_SERPENT_043",
    REPTILE_BLACK_SERPENT_LARGE_044: "REPTILE_BLACK_SERPENT_LARGE_044",
    REPTILE_BLACK_SERPENT_POISONOUS_045: "REPTILE_BLACK_SERPENT_POISONOUS_045",
    REPTILE_GREEN_SNAKE_SMALL_046: "REPTILE_GREEN_SNAKE_SMALL_046",
    REPTILE_GREEN_SNAKE_047: "REPTILE_GREEN_SNAKE_047",

};